import React from 'react';
import { clickAddToBasketAction } from 'utils';

export default Component => props => (
    <Component {...props} addToCart={clickAddToBasketAction() || (() => {})} />
);
